<template>
  <div class="h-100">
    <div v-if="!isLoading">
      <div class="w-100 position-fixed bg-white border-bottom">
        <b-button v-if="isShowingClose" @click="$emit('close')" variant="transparent" class="mt-2 mr-4 float-right">
          <img src="@/assets/icons/close.svg" class="icon icon-sm" />
        </b-button>

        <h1 v-if="!isMobile" v-html="name" class="mt-4" />
        <h5 v-else v-html="name" class="d-inline-block mt-2 ml-1" />
      </div>

      <p v-html="content" />

      <layout-spacer />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { GET } from "@/store/actions";

import { BButton } from "bootstrap-vue";
import Fuse from "fuse.js";

import { toSlug } from "@/helpers/utils";

import LayoutSpacer from "@/components/Layouts/Spacer";

export default {
  name: "BaseResource",
  components: {
    BButton,
    LayoutSpacer,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    documentId: {
      type: String,
      required: true,
    },
    quote: {
      type: String,
      default: "",
    },

    isShowingClose: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({ resources: (state) => state.resources.items }),
    name() {
      const { documentId } = this;
      return this.resources[documentId]?.title;
    },

    styleDocument() {
      const { isMobile } = this;

      if (!isMobile) return "margin-left: 35px";
      return "";
    },

    isMobile() {
      const { value } = this.$screen.alias;
      return value === "xs" || value === "sm" || value === "md";
    },
  },
  data: () => ({
    content: null,

    isLoading: true,
    isSending: false,
  }),
  async mounted() {
    this.triggerGetResource();
  },
  watch: {
    quote() {
      this.highlightQuote();
      this.scrollToHighlightedQuote();
    },
  },
  methods: {
    ...mapActions("projectsResources", { getResource: GET }),
    async triggerGetResource() {
      this.isLoading = true;

      const { documentId: id } = this;
      const country = "france";
      const { content } = await this.getResource({ id, country });

      this.content = content.replace(/\n/g, "<br>");

      this.highlightQuote();
      this.isLoading = false;

      this.scrollToHighlightedQuote();
    },

    highlightQuote() {
      if (!this.quote || !this.content) return;

      const cleanQuote = this.quote.replace(/^\d+\.\s*/, "").trim();
      const contentLines = this.content.split("<br>");

      const fuse = new Fuse(contentLines, {
        includeMatches: true,
        threshold: 0.3,
        location: 0,
        distance: 100,
        minMatchCharLength: 3,
      });

      const result = fuse.search(cleanQuote);

      if (result.length > 0) {
        let startIndex = result[0].refIndex;
        let endIndex = startIndex;
        let matchedText = result[0].item;

        // Check if the next line is also part of the quote
        while (endIndex < contentLines.length - 1) {
          const nextLine = contentLines[endIndex + 1];
          if (cleanQuote.includes(nextLine.trim())) {
            endIndex++;
            matchedText += "<br>" + nextLine;
          } else {
            break;
          }
        }

        // Highlight the matched text
        const highlightedText = `<span class='highlighted-quote' data-quote='${toSlug(this.quote)}'>${matchedText}</span>`;
        contentLines.splice(startIndex, endIndex - startIndex + 1, highlightedText);
        this.content = contentLines.join("<br>");
      }
    },

    async scrollToHighlightedQuote() {
      await this.$nextTick();

      const highlightedElement = document.querySelector(`[data-quote="${toSlug(this.quote)}"]`);
      console.log("highlightedElement");
      console.log(highlightedElement);

      if (highlightedElement) {
        highlightedElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
  },
};
</script>

<style>
.highlighted-quote {
  background-color: yellow;
  font-weight: bold;
}
</style>
